import {
	Button,
	Card,
	Progress,
	Typography,
	Statistic,
	Row,
	Col,
	Space,
	Divider,
} from "antd";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import PrimaryButton from "./Buttons/PrimaryButton";
import { DataContext } from "../contexts/DataContext";

const { Title, Text } = Typography;

export default function AIUsage({ isLoading = false }) {
	const navigate = useNavigate();
	const { creditHandlers } = useContext(DataContext);
	const { creditData } = creditHandlers;

	const onUpgrade = () => {
		navigate("/settings?tab=billing");
	};

	if (isLoading) {
		return (
			<Card>
				<Title level={4}>📊 AI Credit Usage</Title>
				<Row gutter={16}>
					<Col span={8}>
						<Statistic title="Total" value={null} loading />
					</Col>
					<Col span={8}>
						<Statistic title="Used" value={null} loading />
					</Col>
					<Col span={8}>
						<Statistic title="Available" value={null} loading />
					</Col>
				</Row>
				<Divider />
				<Button block loading style={{ height: 40 }} />
			</Card>
		);
	}

	return (
		<Card style={{ borderRadius: 12,height:'100%' }}>
			<Title level={4} style={{ marginBottom: 16 }}>
				📊 AI Credit Usage
			</Title>

			{/* Credit Summary */}
			<Row gutter={16} style={{ marginBottom: 16 }}>
				<Col span={8}>
					<Statistic
						title="Total Credits"
						value={creditData.total}
						prefix={<ArrowUpOutlined />}
						valueStyle={{ color: "#3f8600" }}
					/>
				</Col>
				<Col span={8}>
					<Statistic
						title="Used Credits"
						value={creditData.used}
						prefix={<ArrowDownOutlined />}
						valueStyle={{ color: "#cf1322" }}
					/>
				</Col>
				<Col span={8}>
					<Statistic
						title="Available"
						value={creditData.available}
						valueStyle={{
							color: creditData.available > 0 ? "#1890ff" : "#ff4d4f",
							fontWeight: 600,
						}}
					/>
				</Col>
			</Row>

			<PrimaryButton onClick={onUpgrade}>
				{creditData.available > 0 ? "Manage Credits" : "Get More Credits"}
			</PrimaryButton>

		</Card>
	);
}
